import React from 'react';
import { LogOut, AlertTriangle } from 'lucide-react';
import NotificationBell from '../../../components/NotificationBell';

export const CrmSidebar = ({ navItems, section, onSelect, userLabel, onLogout, onBellNavigate }) => (
  <aside data-testid="admin-sidebar" style={{
    width: 220, flexShrink: 0, background: '#FAFBFC', borderRight: '1px solid #E5E7EB',
    display: 'flex', flexDirection: 'column', height: '100vh', position: 'sticky', top: 0,
  }}>
    <div style={{ padding: '1.25rem 1rem 0.75rem', borderBottom: '1px solid #E5E7EB' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: '1rem', color: 'var(--navy)' }}>
          LMA CRM
        </div>
        <NotificationBell onNavigate={onBellNavigate} />
      </div>
      <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>{userLabel}</div>
    </div>
    <nav style={{ flex: 1, padding: '0.5rem' }}>
      {navItems.map(item => (
        <button
          key={item.id}
          onClick={() => onSelect(item.id)}
          data-testid={`nav-${item.id}`}
          style={{
            width: '100%', display: 'flex', alignItems: 'center', gap: '0.625rem',
            padding: '0.625rem 0.75rem', border: 'none', borderRadius: 6, cursor: 'pointer',
            fontSize: '0.875rem', fontWeight: section === item.id ? 600 : 400,
            fontFamily: 'var(--font-body)', marginBottom: 2,
            background: section === item.id ? '#E8F0FE' : 'transparent',
            color: section === item.id ? '#1A56DB' : '#4B5563',
          }}
        >
          {item.icon}
          <span style={{ flex: 1, textAlign: 'left' }}>{item.label}</span>
          {item.count !== undefined && item.count > 0 && (
            <span style={{
              fontSize: '0.7rem', fontWeight: 600, padding: '1px 6px', borderRadius: 100,
              background: item.isOverdue ? '#FEE2E2' : (section === item.id ? '#C7D7FE' : '#E5E7EB'),
              color: item.isOverdue ? '#DC2626' : (section === item.id ? '#1A56DB' : '#6B7280'),
            }}>{item.count}</span>
          )}
          {item.alert && (
            <AlertTriangle size={14} style={{ color: '#F59E0B' }} />
          )}
        </button>
      ))}
    </nav>
    <div style={{ padding: '0.75rem', borderTop: '1px solid #E5E7EB' }}>
      <button onClick={onLogout} data-testid="admin-logout-btn" style={{
        width: '100%', display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center',
        padding: '0.5rem', border: '1px solid #E5E7EB', borderRadius: 6, background: '#fff',
        cursor: 'pointer', fontSize: '0.813rem', color: '#6B7280', fontFamily: 'var(--font-body)',
      }}>
        <LogOut size={14} /> Sign Out
      </button>
    </div>
  </aside>
);
